import { Component, OnInit, TemplateRef } from '@angular/core';
import { Outputformat } from './outputformat';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, PatternValidator } from '@angular/forms';
import { OutputformatService } from './outputformat.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-outputformat',
  templateUrl: './outputformat.component.html',
  styleUrls: ['./outputformat.component.css']
})
export class OutputformatComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'Output Format';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  outputformatForm: FormGroup;
  outputformats: Outputformat[] = [];
  outputformatsactive: Outputformat[] = [];
  outputformat: Outputformat;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  outputformatModalRef: BsModalRef;
  operation: string;
  userid: number;
  outputformatid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
    private outputformatservice: OutputformatService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('OutputFormat_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('OutputFormat_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('OutputFormat_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('OutputFormat_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.outputformatForm = this.formBuilder.group({
      outputformatid: [''],
      outputformat: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'outputformat'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.outputformats = [];
    this.outputformatsactive = [];
    this.outputformatservice.Get().subscribe(res => {
      this.outputformats = res;
      if (this.showallstatus == true) {
        this.outputformats.forEach(data => {
          if (data.active == 1) {
            this.outputformatsactive.push(data);
          }
        });
        this.outputformats = [];
        this.outputformats = this.outputformatsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.outputformatsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.outputformats.forEach(data => {
        if (data.active == 1) {
          this.outputformatsactive.push(data);
        }
      });
      this.outputformats = [];
      this.outputformats = this.outputformatsactive;
    }
    else {
      this.showall = true;
      this.outputformats = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedOutputFormat");
    let data = arrays.find(ob => ob['name'] === 'Output Format');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedOutputFormat","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedOutputFormat",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.outputformatModalRef.hide();
  }


  get g() { return this.outputformatForm.controls; }

  Post(outputformat: Outputformat) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.outputformatForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.outputformatForm.errors);
    //}
    if ((outputformat.outputformat.trim() == undefined) || (outputformat.outputformat.trim() == '')) {
      this.toastr.error('Output Format should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    outputformat.outputformat = outputformat.outputformat.trim();
    if (this.operation == 'add') {

      outputformat.createdby = this.userid;
      msg = "Record Added Successfully";
      this.outputformatservice.Post(outputformat).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.outputformatModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      outputformat.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.outputformatservice.Put(outputformat).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.outputformatModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.outputformatForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.outputformatForm.value.active = 1;
    } else {
      this.outputformatForm.value.active = 0
    }
  }

  OpenConfirmTemplate(outputformat, template: TemplateRef<any>) {
    if (outputformat.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.outputformat = outputformat;

          this.Delete();

        }

      });

  }


  Delete() {
    var msg;
    if (this.outputformat.active == 0) {
      this.outputformat.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.outputformat.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.outputformat.modifiedby = this.userid;
    this.outputformatservice.Delete(this.outputformat).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.outputformatModalRef.hide();
  }
  openOutputformatModal(template: TemplateRef<any>, type, outputformat?: Outputformat) {
    this.operation = type

    if (type == 'update') {
      this.outputformatForm.controls['outputformatid'].setValue(outputformat.outputformatid);
      this.outputformatForm.controls['outputformat'].setValue(outputformat.outputformat);
      this.outputformatForm.controls['active'].setValue(outputformat.active);
      this.outputformat = outputformat;
    }
    if (type == 'add') {
      this.outputformatForm.controls['outputformatid'].setValue(0);
      this.outputformatForm.controls['outputformat'].setValue('');
      this.outputformatForm.controls['active'].setValue(1);
    }
    this.outputformatModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }




}
